import {
  fieldContainer,
  fieldControlBase,
  fieldControlError,
  fieldErrorText,
  fieldLabel,
} from "./inputTheme";

const SelectInput = ({
  children,
  error,
  label,
  name,
  value,
  required = false,
  register,
  registerOptions = {},
  onChange,
  onBlur,
  disabled = false,
  className,
  style,
}) => {
  const registerResult = register
    ? register(name, { required, ...registerOptions })
    : {};
  const {
    ref,
    onChange: registerOnChange,
    onBlur: registerOnBlur,
    ...restRegister
  } = registerResult;

  return (
    <div className={`${fieldContainer} ${className || ""}`}>
      {label && (
        <label htmlFor={name} className={fieldLabel}>
          {label}
        </label>
      )}

      <select
        id={name}
        className={`${fieldControlBase} ${error ? fieldControlError : ""}`}
        {...restRegister}
        ref={ref}
        onChange={(e) => {
          registerOnChange?.(e);
          onChange?.(e);
        }}
        onBlur={(e) => {
          registerOnBlur?.(e);
          onBlur?.(e);
        }}
        value={value}
        style={style}
        disabled={disabled}
      >
        {children}
      </select>

      {error && (
        <small className={fieldErrorText}>{error}</small>
      )}
    </div>
  );
};

export default SelectInput;
